import React, { useState, useEffect } from 'react';

interface DroppableZoneProps {
  id: string;
  data: any;
  onFilesUpdate: (files: File[]) => void;
}

export default function DroppableZone({ id, data, onFilesUpdate }: DroppableZoneProps) {
  const [files, setFiles] = useState<File[]>([]);
  const [isDragging, setIsDragging] = useState(false);

  // Inicializa os arquivos quando o componente montar ou quando os dados mudarem
  useEffect(() => {
    if (data?.files) {
      setFiles(data.files);
    }
  }, [data]);

  const updateNodeData = (newFiles: File[]) => {
    setFiles(newFiles);
    onFilesUpdate(newFiles);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    // Aceita apenas o primeiro arquivo e substitui o anterior
    updateNodeData(droppedFiles.slice(0, 1));
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDeleteFile = (index: number) => {
    const newFiles = files.filter((_, i) => i !== index);
    updateNodeData(newFiles);
  };

  return (
    <section
      className={`droppable-zone ${isDragging ? 'dragging' : ''}`}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      data-node-id={id}
    >
      <div className="drop-hint">
        <p>Arraste para aqui</p>
      </div>
    </section>
  );
}

